import AmplitudeAnalytics from '@services/amplitude';
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import { Typography } from '@components/atoms/Typography';
import { BenefitsSection } from '@components/organisms/Benefits';
import { DownloadLink } from '@components/organisms/DownloadLink';
import { StartStepsSection } from '@components/organisms/StartSteps';
import { SummarySection } from '@components/organisms/Summary';
import { LandingPage } from '@components/templates/Landing';

import { TPaymentData } from './types';

export const DownloadPage: React.FC = () => {
  const { paymentExternalId } = useParams();
  const location = useLocation();
  const [paymentData, setPaymentData] = useState<TPaymentData | null>();

  useEffect(() => {
    // Handle Base64 query param "data"
    const params = new URLSearchParams(location.search);
    const encodedData = params.get('data');

    // ------------amp event -------------
    AmplitudeAnalytics.downloadAstroPayLandingImpression(paymentExternalId || '');
    // ------------amp event -------------

    if (encodedData) {
      try {
        const decodedString = atob(encodedData);
        const parsedData = JSON.parse(decodedString);

        setPaymentData(parsedData);
      } catch (error) {
        console.error('Failed to decode or parse Base64 data:', error);
        setPaymentData(null);
      }
    }
  }, [location.search]);

  return (
    <LandingPage>
      <div className="flex flex-col gap-6 main-content p-4 md:w-[480px]">
        <div className="flex flex-col text-center">
          <Typography
            variant="h1"
            weight={500}
            textKey="AstroPayDownload.subtitle"
            className="text-[20px]"
          />
          <Typography textKey="AstroPayDownload.description" className="hidden md:block" />
        </div>
        <div className="flex flex-row gap-8">
          <div className="flex-1 flex flex-col gap-4 justify-center items-center">
            <SummarySection
              amount={paymentData?.amount}
              currency={paymentData?.currency}
              paymentExternalId={paymentExternalId}
            />

            <DownloadLink
              paymentExternalId={paymentExternalId}
              action="copyLink"
              className="hidden md:block w-[300px]"
            />
            <BenefitsSection />
          </div>
        </div>
        <StartStepsSection />
      </div>
    </LandingPage>
  );
};
